<template>
  <svg width="14" height="10" viewBox="0 0 14 10" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M6.99893 3.09082C5.94574 3.09082 5.08984 3.94672 5.08984 4.99991C5.08984 6.0531 5.94574 6.909 6.99893 6.909C8.05212 6.909 8.90802 6.0531 8.90802 4.99991C8.90802 3.94672 8.05209 3.09082 6.99893 3.09082Z"
        fill="currentColor"/>
    <path
        d="M7.00002 0.227295C3.81818 0.227295 1.10092 2.20637 0 5.00003C1.10092 7.79365 3.81818 9.77276 7.00002 9.77276C10.185 9.77276 12.8991 7.79365 14 5.00003C12.8991 2.20637 10.185 0.227295 7.00002 0.227295ZM7.00002 8.18183C5.24365 8.18183 3.81818 6.75636 3.81818 5C3.81818 3.24363 5.24365 1.8182 7.00002 1.8182C8.75638 1.8182 10.1818 3.24366 10.1818 5.00003C10.1818 6.75639 8.75638 8.18183 7.00002 8.18183Z"
        fill="currentColor"/>
  </svg>

</template>

<script>
export default {
  name: "IconEye"
}
</script>